/**
 * Helper function to convert Stripe amount to decimal based on currency
 * Some currencies like JOD, BHD, KWD use 3 decimal places (1000 fils = 1 JOD)
 * while most currencies use 2 decimal places (100 cents = 1 USD)
 *
 * @param {number} amount - The amount in smallest currency unit from Stripe
 * @param {string} currencyCode - The ISO currency code (e.g., 'USD', 'JOD', 'EUR')
 * @returns {number} - The converted decimal amount
 */
export const convertStripeAmount = (amount, currencyCode) => {
  // Currencies that use 3 decimal places (smallest unit is 1/1000)
  const threeDecimalCurrencies = ['JOD', 'BHD', 'KWD', 'OMR', 'TND'];

  const divisor = threeDecimalCurrencies.includes(currencyCode) ? 1000 : 100;
  return amount / divisor;
};
